import React from 'react';
import DisplayNotes from './DisplayNotes';
import OuterContainer from '../PatientSummary/OuterContainer';

import { ROPatientContextProvider } from '../PatientSummary/context';
import { Grid } from '@mui/material';

const Notes = (): JSX.Element => {
  return (
    <ROPatientContextProvider>
      <OuterContainer>
        <Grid container sx={{ padding: '0 16px' }}>
          <Grid
            xs={12}
            sx={{
              padding: '16px',
              borderRadius: '4px',
              boxShadow: '0px 2px 8px rgba(113, 110, 106, 0.4)',
              backgroundColor: 'white',
            }}>
            <DisplayNotes />
          </Grid>
        </Grid>
      </OuterContainer>
    </ROPatientContextProvider>
  );
};

export default Notes;
